import { Button, Form } from "react-bootstrap";
import { useCallback, useState } from "react";
// styles
import styles from "./styles.module.scss";
// components
import ModalLayout from "components/modal/modal-layout/ModalLayout";
// constants
import messages from "messages";
// hooks
import useId from "hooks/useId";

type Props = {
  show: boolean;
  onApply: (arg: TreatmentPlan["type"]) => void;
  onCancel: () => void;
};

const PLAN_TYPES = Object.freeze({
  BASIC: messages.basic,
  ADVANCED: messages.advanced,
});

const TreatmentPlanType = ({ show, onApply, onCancel }: Props) => {
  const [type, setType] = useState<TreatmentPlan["type"] | undefined>();

  const id = useId("type");

  const handleApply = useCallback(() => {
    if (type) {
      onApply(type);
    }
    setType(undefined);
  }, [onApply, type]);

  const handleCancel = useCallback(() => {
    setType(undefined);
    onCancel();
  }, [onCancel]);

  return (
    <ModalLayout
      show={show}
      onHide={handleCancel}
      Header={
        <span className={styles["treatment-plan-type__title"]}>
          {messages.addTreatmentPlan}
        </span>
      }
      headerClass={styles["treatment-plan-type__header"]}
      bodyClass={styles["treatment-plan-type__body"]}
      Footer={
        <Button
          className={styles["treatment-plan-type__apply"]}
          size="sm"
          type={"submit"}
          onClick={handleApply}
        >
          {messages.choose}
        </Button>
      }
      footerClass={styles["treatment-plan-type__footer"]}
    >
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          handleApply();
        }}
      >
        <label htmlFor={id} className={styles["treatment-plan-type__label"]}>
          {messages.chooseATreatmentPlan}
        </label>
        <div id={id}>
          {Object.entries(PLAN_TYPES).map(([key, value]) => (
            <Button
              key={key}
              className={styles["treatment-plan-type__plan-type"]}
              size="lg"
              variant={"outline-primary"}
              onClick={() => setType(key as typeof type)}
              active={type === key}
            >
              {value}
            </Button>
          ))}
        </div>
      </Form>
    </ModalLayout>
  );
};
export default TreatmentPlanType;
